import ProductCategoryService from "../../services/ProductCategoryService";

const productCategoryService = new ProductCategoryService();

const state = {
    productCategories: [],
    productCategoryToEdit: null,
    editMode: false,
    parentId: null,
};

const getters = {
    productCategories: state => state.productCategories,
    productCategoryToEdit: state => state.productCategoryToEdit,
    editMode: state => state.editMode,
    parentId: state => state.parentId,
};

const mutations = {
    setProductCategories: (state, productCategories) => (state.productCategories = productCategories),
    setProductCategoryToEdit: (state, productCategoryToEdit) => (state.productCategoryToEdit = productCategoryToEdit),
    setEditMode: (state, editMode) => (state.editMode = editMode),
    setParentId: (state, parentId) => (state.parentId = parentId),
};

const actions = {
    async fetchProductCategories({commit}) {
        const {data} = await productCategoryService.fetchCategories();
        commit('setProductCategories', data);
    },
    async saveCategory({commit}, data) {
        await productCategoryService.save(data.name, data.parentId);
    },
    async updateCategory({commit}, data) {
        await productCategoryService.update(data.id, data.name);
    },
    setEditMode({commit}, editMode) {
        commit('setEditMode', editMode);
    },
    setProductCategoryToEdit({commit}, data) {
        const productCategory = data === null ? null : {
            id: data.id,
            name: data.name,
        };
        commit('setProductCategoryToEdit', productCategory);
    },
    async deleteProductCategory({commit}, id) {
        await productCategoryService.delete(id);
    },
    setParentId({commit}, parentId) {
        commit('setParentId', parentId);
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};
